<template>
    <h1>nic</h1>
    <div class="row">
        <div class="col-12">
            <div class="card my-3">
                <div class="card-header">
                    Editar
                    
                </div>
                <div class="card-body">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th width="10px">ID</th>
                            <th>titulo</th>
                            <th >Editar</th>
                            <th >Eliminar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="nic in v_nics" v-bind:key="nic.id">
                            <td>{{ nic.id }}</td>
                            <td>{{ nic.title }} - {{ nic.lang }}</td>
                            <td width="10px">
                                <nic-edit :nic_props="nic"></nic-edit>
                            </td>
                            <td width="10px">
                                <nic-delete :nic_props="nic"></nic-delete>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </div>
        </div>
    </div>
  
</template>
<script>
    import nicEdit from '../components/web/nic/nicEdit.vue';
    import nicDelete from '../components/web/nic/nicDelete.vue';
    import { useStore } from 'vuex';
    import {ref,computed,onMounted} from 'vue'

    export default{
        name:'nicView',
        components:{
            nicEdit,
            nicDelete
        },
        setup(){

            const store = useStore()
            const v_nics = computed(()=> store.state.nic.v_nics)
            const modal_edit = ref(false)
            onMounted(()=>{
                store.dispatch('nic/v_actions_nics')
                
            })
            return{
                v_nics,
                modal_edit

            }
        }
    }
</script>